<script lang="ts">
	import type { Snippet } from "svelte";
	import HugeHeading from "./HugeHeading.svelte";
	import Formatted from "./common/Formatted.svelte";

	let {
		/* eslint-disable prefer-const */
		active,
		heading,
		level,
		children,
		/* eslint-enable prefer-const */
		root = $bindable(),
	}: { level: number; heading: string; active: boolean; root?: HTMLElement; children: Snippet } = $props();

	const isEven = $derived(level % 2 === 0);
</script>

<div class="grid-container 2xl:[--container-width:min(86%,1664px)] relative group" bind:this={root}>
	<div
		class={[
			"mb-12 md:mb-32 z-10 w-full",
			level === 0
				? "container-6 pt-32"
				: "mx-auto flex flex-col gap-x-48 lg:flex-row lg:items-center lg:group-odd:flex-row-reverse",
		]}
	>
		{#if level > 0}
			<HugeHeading
				level={2}
				text={level.toString().padStart(2, "0")}
				aria-label="Krok číslo {level}"
				class={[
					"transition-colors !text-cmcbg mb-2 lg:mb-0 lg:basis-full text-[6rem]/[0.9] md:text-[15rem]/[0.9] lg:text-[20rem]/[0.9]",
					active ? "stroke-text-cmcprimary" : "stroke-text-cmcsecondary",
					isEven ? "text-right lg:text-left" : "text-left lg:text-right",
				]}
			/>
		{/if}
		<div
			class={[
				level === 0 ? "mx-auto justify-between" : "basis-full",
				"bg-white/50 p-3 md:p-6 flex flex-col rounded-3xl backdrop-blur-[8px] max-w-[44rem]",
			]}
		>
			<h3 class="font-semibold text-base/[1.2] md:text-xl/[1.2] text-cmcsecondary">
				<Formatted text={heading} />
			</h3>
			{@render children()}
		</div>
	</div>
</div>
